// extracted by mini-css-extract-plugin
module.exports = {"section":"sectionMetodo-module--section--LObGJ","image":"sectionMetodo-module--image--LLUsT"};